import React from 'react';

const ApplicantInfoDescription = () => (
  <>
    <p>Enter this information for the applicant or the beneficiary.</p>
    <p>
      <strong>Note:</strong> The applicant or beneficiary is the person applying
      for or getting CHAMPVA benefits. This person is not the Veteran sponsoring
      the benefits.
    </p>
  </>
);

export default ApplicantInfoDescription;
